import {createAction} from '@reduxjs/toolkit';
import {
  type FeatureCollectionId,
  type FeatureRef,
} from '@src/types/featureCollections.ts';

const actionPrefix = 'FEATURE_COLLECTIONS';

export const selectCollectionFeatures = createAction<FeatureRef[]>(
  `${actionPrefix}/SELECT_COLLECTION_FEATURES`,
);

export const setFeatureDetailsRef = createAction<FeatureRef | null>(
  `${actionPrefix}/SET_FEATURE_DETAILS_REF`,
);

export const setShowQuotaManagement = createAction<boolean>(
  `${actionPrefix}/SET_SHOW_QUOTA_MANAGEMENT`,
);

export const setVisibleCollection = createAction<FeatureCollectionId | null>(
  `${actionPrefix}/SET_VISIBLE_COLLECTION`,
);
